import React from "react";

const IconButton = (props: any, ref: any ) => {
  return (
    <div id={`${props.id}Chart`} onClick={props.onClick} className={props.className} ref={ref} data-tooltip={props.dataTooltip}>
      {props.children}
    </div>
  );
};

export default React.forwardRef(IconButton);
